module.exports = __webpack_public_path__ + "static/media/it.61280cdc.svg";